<template>
    <v-card>
        <v-container class="pa-0">
            <v-row no-gutters>
                <v-col cols="4">
                    <v-list>
                        <v-list-item-group
                            v-model="selectedPaymentMethod"
                            mandatory
                            color="primary"
                        >
                            <v-list-item
                                v-for="(item, i) in paymentMethods"
                                :key="i"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        item.text
                                    }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon>
                                    <fa
                                        :icon="['fal', `${item.icons[0]}`]"
                                        class="fa-lg"
                                    />
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-col>
                <v-col cols="8">
                    <AchForm v-if="selectedPaymentMethod === 0" />
                    <CreditCardForm v-else-if="selectedPaymentMethod === 1" />
                    <div class="px-3" v-if="cardValidationErrorMessage">
                        <v-alert dense text type="error">
                            {{ cardValidationErrorMessage }}
                        </v-alert>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import CreditCardForm from '~/components/PaymentGateway/CreditCardForm.vue'
import AchForm from '~/components/PaymentGateway/AchForm.vue'
export default {
    name: 'PaymentGatewayTemplate',
    components: {
        CreditCardForm,
        AchForm,
    },

    props: {
        cardValidationErrorMessage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedPaymentMethod: 0,
            paymentMethods: [
                {
                    text: 'ACH',
                    value: 'ach',
                    icons: ['university'],
                },
                {
                    text: 'Credit Card',
                    value: 'creditCard',
                    icons: ['credit-card'],
                },
            ],
        }
    },
    computed: {},
    watch: {
        selectedPaymentMethod(newVal) {
            this.$emit('setPaymentMethod', this.paymentMethods[newVal].value)
            this.$store.dispatch('paymentGateway/clearPaymentFields')
        },
    },
    mounted() {
        this.$emit(
            'setPaymentMethod',
            this.paymentMethods[this.selectedPaymentMethod].value
        )
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.svg-inline--fa {
    color: #000;
}
.v-item--active {
    .svg-inline--fa {
        color: $primary;
    }
}
</style>
